import moment from 'moment'

export function getDateString(unixTimeStamp) {
    let dateString = moment.unix(unixTimeStamp).format('MM/DD/YYYY')
    return dateString;
}

export function getTimeString(unixTimeStamp) {
    let timeString = moment.unix(unixTimeStamp).format('h:mm a')
    return timeString;
}